import '../../form.css'
import { withRouter } from 'react-router-dom/cjs/react-router-dom';

const ReportCellValue = ({ value }) => (
    <div className="report-table-value">{value || ''}</div>
);

const Index = ({ state }) => {

    return (
        <div className="row">
            <div className="col-md-12 ">
                <div className="appraisal-report-table-responsive">
                    <table
                        className="assessment-table inspn-assessment-table"
                        cellSpacing={0}
                    >
                        <tbody>
                            <tr className="bghed">
                                <td className="hd-s2 pd10">
                                    {" "}
                                    <p>S.No.</p>
                                </td>
                                <td className="hd-s2 pd10 w150">
                                    <p>Date Issued</p>
                                </td>
                                <td className="hd-s2 pd10 w150">
                                    <p>Drawing Number</p>
                                </td>

                                <td className="hd-s1 pd10">
                                    <p>Subject</p>
                                </td>
                                <td className="hd-s2 pd10 w150">
                                    <p>Revision Number

                                    </p>
                                </td>
                                <td className="hd-s2 pd10 w150">
                                    <p>Remark

                                    </p>
                                </td>

                            </tr>

                            {state.map((item, index) => {
                                return (
                                    <tr>
                                        <td className="td-s1">
                                            <p className="s1">{index + 1}.</p>
                                        </td>
                                        <td className="tb-input-value">
                                            <ReportCellValue value={item.date_issued.value} />
                                        </td>

                                        <td className="tb-input-value">
                                            <ReportCellValue value={item.drawing_number.value} />
                                        </td>
                                        <td className="tb-input-value">
                                            <ReportCellValue value={item.subject.value} />
                                        </td>
                                        <td className="tb-input-value">
                                            <ReportCellValue value={item.revision_number.value} />
                                        </td>
                                        <td className="tb-input-value">
                                            <ReportCellValue value={item.remark.value} />
                                        </td>


                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default withRouter(Index)
